import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/articles/ArticleClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/articles/ArticleDetailClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/contact/Contact.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/features/features.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/newsletter/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/testimonies/Testimonies.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/video/video.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ErrorFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/hero/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/nav/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/popup/AdmissionPopup.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/whatsapp-chat/WhatsApp-Chat.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/gallery.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/hero.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/president.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/values.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/aboutpage1.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/accre.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/accresm.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/admission.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/admissionsm.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/bottomleft.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/bottomright.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/career.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/careersm.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/cele3.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/celeberate2.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/featuresimg.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/organic.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/organicsm.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/president_new.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/recog.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/recogsm.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/wnf.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/wnfsm.jpg");
